import { qs, qsa, on, delegate } from '../lib/dom.js';
import { revealTitle } from './entrance-animations.js';
import { runCounters } from './counters.js';

const AUTO_MS = 12000;

export function initHeroCarousel() {
  const root = qs('[data-component="hero-carousel"]');
  if (!root) return;
  // Feed the same duration to the CSS "stories" fill bar (see hero.css).
  root.style.setProperty('--ap-hero-auto', `${AUTO_MS}ms`);

  const slides = qsa('.ap-hero__slide', root);
  const dots = qsa('[data-go]', root);
  const counter = qs('[data-role="counter"]', root);
  const monthly = qs('[data-role="hero-monthly"]', root);
  const monthlies = [489, 812, 559, 639]; // mirror slides
  let index = 0;

  function goTo(i) {
    index = (i + slides.length) % slides.length;
    slides.forEach((s, k) => {
      const active = k === index;
      s.classList.toggle('is-active', active);
      s.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    dots.forEach((d, k) => d.classList.toggle('is-active', k === index));
    if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    if (monthly) monthly.textContent = monthlies[index] ?? monthlies[0];
    // Per-character reveal of the active slide's title
    const activeSlide = slides[index];
    const activeTitle = activeSlide && activeSlide.querySelector('.ap-hero__title');
    if (activeTitle) revealTitle(activeTitle);
    // Re-run counters whenever a slide containing them becomes active
    if (activeSlide) runCounters(activeSlide, { force: true });
  }

  const pause = () => root.classList.add('is-paused');
  const play = () => root.classList.remove('is-paused');

  // Instagram-stories autoplay: the active dot's fill bar animates over AUTO_MS
  // (CSS), and the animation COMPLETING is what advances to the next slide - so
  // the progress indicator and the advance are always in sync, incl. pause/resume
  // (the .is-paused class holds both). When prefers-reduced-motion is on, the fill
  // animation doesn't run (see hero.css), so there's no auto-advance - matching the
  // old behavior; manual nav still works.
  on(root, 'animationend', (e) => {
    if (e.animationName === 'ap-hero-dot-fill') goTo(index + 1);
  });

  delegate(root, 'click', '[data-action="prev"]', () => goTo(index - 1));
  delegate(root, 'click', '[data-action="next"]', () => goTo(index + 1));
  delegate(root, 'click', '[data-go]', (e, el) => goTo(Number(el.dataset.go)));

  on(root, 'mouseenter', pause);
  on(root, 'mouseleave', play);
  on(document, 'visibilitychange', () => (document.hidden ? pause() : play()));

  // Touch swipe
  let startX = 0, dx = 0, swiping = false;
  on(root, 'touchstart', (e) => { startX = e.touches[0].clientX; swiping = true; pause(); }, { passive: true });
  on(root, 'touchmove', (e) => { if (swiping) dx = e.touches[0].clientX - startX; }, { passive: true });
  on(root, 'touchend', () => {
    if (Math.abs(dx) > 40) goTo(index + (dx < 0 ? 1 : -1));
    swiping = false; dx = 0; play();
  });

  // Kick off: activating slide 0 starts its dot's fill, which drives the loop.
  goTo(index);
}
